export { default as InducteeHero } from './InducteeHero';